<template>
  <div class="root-container">
    <div class="table-container">
    <!-- 搜索栏（固定） -->
    <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
      <!-- 电脑端使用 Element UI 搜索框 -->
      <div v-if="isDesktop" class="desktop-search-wrapper">
        <div class="search-row">
          <el-input 
            v-model="searchKeyword" 
            placeholder="请输入账号搜索" 
            clearable
            size="small"
            class="search-input"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <div class="button-group">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="handleOpenAdd"
              class="add-button"
            >
              添加
            </el-button>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-filter" 
              @click="toggleFilter"
              class="filter-button"
            >
              {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
            </el-button>
          </div>
        </div>
        
        <!-- 电脑端筛选面板 -->
        <div v-if="isFilterOpen" class="filter-panel">
          <div class="filter-row">
            <div class="filter-item">
              <label>企业：</label>
              <el-select v-model="filterForm.group_id" placeholder="请选择需搜索企业" filterable clearable size="small" style="width: 150px;" v-if="groupID === 1">
                <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>标签：</label>
              <el-select v-model="filterForm.tag_id" placeholder="请选择需搜索标签" clearable size="small" style="width: 150px;">
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.tag_id">
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>状态：</label>
              <el-select v-model="filterForm.status" placeholder="请选择状态" clearable size="small" style="width: 120px;">
                <el-option v-for="item in status" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="filter-actions">
            <div class="applied-filters">
              <span v-if="appliedFilterForm.group_id" class="filter-tag">
                企业: {{ getGroupName(appliedFilterForm.group_id) }}
              </span>
              <span v-if="appliedFilterForm.tag_id" class="filter-tag">
                标签: {{ getTagName(appliedFilterForm.tag_id) }}
              </span>
              <span v-if="appliedFilterForm.status" class="filter-tag">
                状态: {{ getStatusLabel(appliedFilterForm.status) }}
              </span>
              <span v-if="!appliedFilterForm.group_id && !appliedFilterForm.tag_id && !appliedFilterForm.status" class="filter-tag filter-tag-empty">
                当前无筛选条件
              </span>
            </div>
            <div class="filter-buttons">
              <el-button size="small" @click="resetFilter">重置筛选</el-button>
              <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 手机端使用 Vant 搜索框 -->
      <div v-else class="mobile-search-wrapper">
        <van-search
          v-model="searchKeyword"
          placeholder="请输入账号搜索"
          show-action
          @search="handleSearch"
          @cancel="onSearchCancel"
          :placeholder-style="{ fontSize: '16px' }"
          :input-align="'center'"
        >
          <template #action>
            <div @click="handleSearch" style="margin-right: 10px; font-size: 16px; color: var(--primary); font-weight: 600;">搜索</div>
          </template>
        </van-search>
        
        <!-- 手机端添加按钮 -->
        <div class="mobile-add-button">
          <van-button 
            type="primary" 
            size="small" 
            block
            icon="plus"
            @click="handleOpenAdd"
            style="margin-top: 10px;"
          >
            添加
          </van-button>
        </div>
        
        <!-- 手机端筛选面板 -->
        <div v-if="isFilterOpen" class="mobile-filter-panel">
          <!-- 手机端已应用筛选条件显示 -->
          <div class="mobile-applied-filters">
            <div v-if="appliedFilterForm.group_id || appliedFilterForm.tag_id || appliedFilterForm.status" class="applied-title">已应用筛选条件：</div>
            <div class="applied-tags">
              <span v-if="appliedFilterForm.group_id" class="mobile-filter-tag">
                企业: {{ getGroupName(appliedFilterForm.group_id) }}
              </span>
              <span v-if="appliedFilterForm.tag_id" class="mobile-filter-tag">
                标签: {{ getTagName(appliedFilterForm.tag_id) }}
              </span>
              <span v-if="appliedFilterForm.status" class="mobile-filter-tag">
                状态: {{ getStatusLabel(appliedFilterForm.status) }}
              </span>
              <span v-if="!appliedFilterForm.group_id && !appliedFilterForm.tag_id && !appliedFilterForm.status" class="mobile-filter-tag empty">
                当前无筛选条件
              </span>
            </div>
          </div>
          
          <van-cell v-if="groupID === 1" title="企业" is-link @click="showGroupPicker = true">{{ getGroupName(filterForm.group_id) || '全部' }}</van-cell>
          <van-cell title="标签" is-link @click="showTagPicker = true">{{ getTagName(filterForm.tag_id) || '全部' }}</van-cell>
          <van-cell title="状态" is-link @click="showStatusPicker = true">{{ getStatusLabel(filterForm.status) || '全部' }}</van-cell>
          <div class="mobile-filter-actions">
            <van-button type="default" size="small" @click="resetFilter">重置</van-button>
            <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
          </div>
        </div>
        
        <!-- 手机端筛选展开按钮 -->
        <div class="mobile-filter-toggle" @click="toggleFilter">
          <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" /> 
          <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      
      <!-- 电脑端表格 -->
      <div class="table-wrapper" v-if="isDesktop">
        <el-table 
          :data="filteredData" 
          style="width: 100%" 
          tooltip-effect="dark" 
          empty-text="暂无数据"
          class="desktop-table"
          :height="tableHeight"
        >
          <el-table-column label="ID" prop="id" align="left" width="80"></el-table-column>
          <el-table-column label="账号" prop="username" align="left" width="140px"></el-table-column>
          <el-table-column label="真实姓名" prop="nickname" align="left" width="150px"></el-table-column>
          <el-table-column label="实名认证" prop="realname_auth" align="left" width="100px">
            <template slot-scope="scope">
              <span v-if="(scope.row.realname_auth === 0)">未认证</span>
              <el-tag v-if="(scope.row.realname_auth === 1)" effect="dark" type="warning" size="mini">认证</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="公司" prop="group" align="left" width="240px">
            <template slot-scope="scope">
              {{ scope.row.group.name }}
            </template>
          </el-table-column>
          <el-table-column label="角色" prop="role" align="left" width="160px">
            <template slot-scope="scope">
              <el-tag v-for="(v, k) in scope.row.role" effect="light" size="mini" :hit="false">{{ v.role_name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="标签" prop="tags" align="left" width="160px">
            <template slot-scope="scope">
              <el-tag v-for="(v, k) in scope.row.tags" effect="dark" size="mini" :color="v.color" :hit="false">{{ v.name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="status" align="left">
            <template slot-scope="scope">
              <span v-if="(scope.row.status === 0)">正常</span>
              <el-tag v-if="(scope.row.status === 1)" effect="dark" type="info" size="small">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right" fixed="right" width="155px">
            <template slot-scope="scope">
              <div class="table-actions">
                <el-link @click="editTable(scope.row.id)">
                  <i class="el-icon-edit" style="font-size:16px;"></i>编辑
                </el-link>
                <el-dropdown @command="command($event, scope.row.id)">
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="resetPass">重置密码</el-dropdown-item>
                    <el-dropdown-item command="ban" v-if="(scope.row.status === 0)">禁用账号</el-dropdown-item>
                    <el-dropdown-item command="unban" v-if="(scope.row.status === 1)">解禁账号</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 手机端卡片 -->
      <div v-else class="mobile-cards">
        <div 
          v-for="item in filteredData" 
          :key="item.id" 
          class="mobile-card"
        >
          <div class="card-header">
            <h3>{{ item.username }}</h3>
            <el-tag :type="item.status === 0 ? 'success' : 'info'" size="small">
              {{ item.status === 0 ? '正常' : '禁用' }}
            </el-tag>
          </div>
          <div class="card-content">
            <p><strong>真实姓名:</strong> {{ item.nickname }}</p>
            <p><strong>公司:</strong> {{ item.group.name }}</p>
            <p><strong>角色:</strong> 
              <el-tag v-for="(v, k) in item.role" :key="k" effect="light" size="mini" :hit="false">{{ v.role_name }}</el-tag>
            </p>
            <p><strong>标签:</strong> 
              <el-tag v-for="(v, k) in item.tags" :key="k" effect="dark" size="mini" :color="v.color" :hit="false">{{ v.name }}</el-tag>
            </p>
            <p><strong>实名认证:</strong> 
              <span v-if="item.realname_auth === 0">未认证</span>
              <el-tag v-else effect="dark" type="warning" size="mini">认证</el-tag>
            </p>
          </div>
          <div class="card-actions">
            <van-button 
              type="primary" 
              size="small" 
              plain
              icon="edit"
              @click="editTable(item.id)"
              style="margin-right: 10px;"
            >
              修改
            </van-button>
            <van-button 
              type="default" 
              size="small" 
              plain
              icon="ellipsis"
              @click="showMoreActions(item)"
            >
              更多操作
            </van-button>
          </div>
        </div>
        
        <!-- 手机端空状态 -->
        <div v-if="filteredData.length === 0" class="mobile-empty">
          暂无数据
        </div>
        
        <!-- 手机端操作菜单，只显示一次 -->
        <van-action-sheet
          v-model="showActionSheet"
          get-container="body"
          :actions="actionSheetActions"
          @select="onActionSheetSelect"
          @close="onActionSheetClose"
        />
      </div>
    </div>
    
    <!-- 分页（固定） -->
    <div class="pagination-container">
      <el-pagination
        v-if="isDesktop"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      
      <el-pagination
        v-else
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[5, 10, 15]"
        :page-size="params.page_count"
        layout="total, prev, pager, next"
        :total="total"
        small
      ></el-pagination>
    </div>
    
    <!-- 手机端选择器弹窗 -->
    <van-popup v-model="showGroupPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="groupColumns"
        @confirm="onGroupConfirm"
        @cancel="showGroupPicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showTagPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="tagColumns"
        @confirm="onTagConfirm"
        @cancel="showTagPicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showStatusPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="statusColumns"
        @confirm="onStatusConfirm"
        @cancel="showStatusPicker = false"
      />
    </van-popup>
    
    <!-- 添加/编辑抽屉 - 电脑端 -->
    <el-drawer v-if="isDesktop" title="更改账号" :visible.sync="editDrawer" :direction="direction" :before-close="handleClose">
      <edit-comp v-if="editDrawer" @close="handleClose" @success="handleDrawerSuccess" :id="editID" ref="newForm"></edit-comp>
    </el-drawer>
    
    <el-drawer v-if="isDesktop" title="添加账号" :visible.sync="addDrawer" :direction="direction" :before-close="handleClose">
      <add-comp @close="handleClose" @success="handleDrawerSuccess" @clear="clearContent" ref="newForm" v-if="addDrawer"></add-comp>
    </el-drawer>
    
  </div>
  
  <!-- 添加/编辑弹窗 - 手机端 -->
  <van-popup
    v-if="!isDesktop" 
    v-model="addPopup" 
    position="bottom" 
    :round="true"
    :close-on-click-overlay="false"
    get-container="body"
    style="max-height:80%"
    @open="handlePopupOpen"
    @close="handlePopupClose"
  >
    <div class="popup-container">
      <div class="popup-header">
        <h3>添加账号</h3>
        <van-icon name="cross" @click="handleClosePopup('add')" class="close-icon" />
      </div>
      <div class="popup-content">
        <add-comp @close="handleClosePopup('add')" @success="handlePopupSuccess" @clear="clearContent" ref="newForm"></add-comp>
      </div>
    </div>
  </van-popup>
  
  <van-popup
    v-if="!isDesktop" 
    v-model="editPopup" 
    position="bottom" 
    :round="true"
    :close-on-click-overlay="false"
    get-container="body"
    style="max-height:80%"
    @open="handlePopupOpen"
    @close="handlePopupClose"
  >
    <div class="popup-container">
      <div class="popup-header">
        <h3>更改账号</h3>
        <van-icon name="cross" @click="handleClosePopup('edit')" class="close-icon" />
      </div>
      <div class="popup-content">
        <edit-comp @close="handleClosePopup('edit')" @success="handlePopupSuccess" :id="editID" ref="newForm"></edit-comp>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
// 静态导入 Vant 弹框组件
import { Dialog, Toast, Icon } from 'vant'
import { searchAdmins, blockAdmin, unblockAdmin, searchTags, searchGroups, resetPassword } from "@/api/system.js";
import addComp from "./components/add.vue";
import editComp from "./components/edit.vue";

let page_name = 'system_admin'
export default {
  name: "newindex",
  components: { addComp, editComp, [Icon.name]: Icon },
  data() {
    return {
      activeName: 'all',
      admin_permission: [],
      groupID: '',
      status: [
        { id: "", label: "全部" },
        { id: 0, label: "正常" },
        { id: 1, label: "禁用" },
        { id: 2, label: "审核中" },
        { id: 3, label: "审核拒绝" },
      ],
      options: [],
      groupList: [],
      
      // 搜索相关
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      isDesktop: true,
      // 筛选相关
      isFilterOpen: false,
      filterForm: {
        group_id: '',
        tag_id: '',
        status: ''
      },
      // 保存已应用的筛选条件
      appliedFilterForm: {
        group_id: '',
        tag_id: '',
        status: ''
      },
      // 手机端选择器
      showGroupPicker: false,
      showTagPicker: false,
      showStatusPicker: false,
      groupColumns: ['全部'],
      tagColumns: ['全部'],
      statusColumns: ['全部', '正常', '禁用', '审核中', '审核拒绝'],
      // 手机端操作菜单
      showActionSheet: false,
      currentRow: null,
      actionSheetActions: [
        { name: '重置密码', type: 'default' },
        { name: '禁用账号', type: 'default' },
        { name: '解禁账号', type: 'default' }
      ],
      
      params: {
        page: 1,
        page_count: 10,
        username: '',
        gender: '',
        mobile: '',
        status: '',
        nickname: '',
        group_id: '',
        tag_id: ''
      },
      
      table: [],
      total: 0,
      editID: '',
      addDrawer: false,
      editDrawer: false,
      addPopup: false,
      editPopup: false,
      direction: "rtl"
    };
  },
  computed: {
    filteredData() {
      return this.table.filter(item => {
        // 关键词搜索
        const keyword = this.searchKeyword.toLowerCase()
        const matchesKeyword = !keyword || item.username.toLowerCase().includes(keyword)
        
        // 标签筛选
        const matchesTag = !this.filterForm.tag_id || item.tags.some(tag => tag.tag_id === this.filterForm.tag_id)
        
        // 企业筛选
        const matchesGroup = !this.filterForm.group_id || item.group.id === this.filterForm.group_id
        
        // 状态筛选
        const matchesStatus = !this.filterForm.status || item.status === this.filterForm.status
        
        return matchesKeyword && matchesTag && matchesGroup && matchesStatus
      })
    },
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 180 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 100 - 40 // 100是其他元素的额外高度，40是标签页高度
    }
  },
  methods: {
    initData() {
      // this.admin_permission = this.$store.state.permission.permissionArr[page_name]
      // this.groupID = this.$store.state.user.userData.group_id
      this.getTableData()
      this.loadTags()
      this.loadGroups()
    },
    loadTags() {
      searchTags().then(res => {
        if (res.code === 200) {
          this.options = res.data.data
          this.tagColumns = ['全部', ...this.options.map(item => item.name)]
        }
      })
    },
    loadGroups() {
      searchGroups().then(res => {
        if (res.code === 200) {
          this.groupList = res.data.data
          this.groupColumns = ['全部', ...this.groupList.map(item => item.name)]
        }
      })
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    // 检查屏幕大小
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    // 处理窗口大小变化
    handleResize() {
      this.checkScreenSize()
    },
    // 处理添加按钮点击
    handleOpenAdd() {
      if (this.isDesktop) {
        this.addDrawer = true
      } else {
        this.addPopup = true
      }
    },
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    // 应用筛选
    applyFilter() {
      // 保存当前筛选条件为已应用条件
      this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
      this.params.page = 1
      this.getTableData()
    },
    // 重置筛选
    resetFilter() {
      // 初始化筛选条件
      const initialFilter = {
        group_id: '',
        tag_id: '',
        status: ''
      }
      // 同时重置当前筛选表单和已应用筛选条件
      this.filterForm = JSON.parse(JSON.stringify(initialFilter))
      this.appliedFilterForm = JSON.parse(JSON.stringify(initialFilter))
      this.params.page = 1
      this.getTableData()
    },
    // 处理编辑
    editTable(id) {
      this.editID = id
      if (this.isDesktop) {
        this.editDrawer = true
      } else {
        this.editPopup = true
      }
    },
    // 手机端企业选择确认
    onGroupConfirm(value) {
      const group = this.groupList.find(item => item.name === value)
      this.filterForm.group_id = value === '全部' ? '' : (group ? group.id : '')
      this.showGroupPicker = false
      this.applyFilter()
    },
    // 手机端标签选择确认
    onTagConfirm(value) {
      const tag = this.options.find(item => item.name === value)
      this.filterForm.tag_id = value === '全部' ? '' : (tag ? tag.tag_id : '')
      this.showTagPicker = false
      this.applyFilter()
    },
    // 手机端状态选择确认
    onStatusConfirm(value) {
      const statusMap = {
        '全部': '',
        '正常': 0,
        '禁用': 1,
        '审核中': 2,
        '审核拒绝': 3
      }
      this.filterForm.status = statusMap[value]
      this.showStatusPicker = false
      this.applyFilter()
    },
    // 获取企业名称
    getGroupName(groupId) {
      if (!groupId) return ''
      const group = this.groupList.find(item => item.id === groupId)
      return group ? group.name : ''
    },
    // 获取标签名称
    getTagName(tagId) {
      if (!tagId) return ''
      const tag = this.options.find(item => item.tag_id === tagId)
      return tag ? tag.name : ''
    },
    // 获取状态标签
    getStatusLabel(statusId) {
      if (statusId === '') return ''
      const status = this.status.find(item => item.id === statusId)
      return status ? status.label : ''
    },
    // 标签页切换
    handleClick(tab, event) {
      this.params.page = 1
      if (this.activeName === 'all') {
        this.params.status = ''
      }
      if (this.activeName === 'default') this.params.status = 0
      if (this.activeName === 'delete') this.params.status = 1
      this.getTableData()
    },
    // 获取表格数据
    getTableData() {
      this.params.username = this.searchKeyword
      this.params.group_id = this.filterForm.group_id
      this.params.tag_id = this.filterForm.tag_id
      this.params.status = this.params.status 
      
      searchAdmins(this.params).then(res => {
        if (res.code === 200) {
          this.table = res.data.data
          this.params.page = res.data.current_page
          this.params.page_count = res.data.per_page
          this.total = res.data.total
          this.$forceUpdate()
        }
      })
    },

    // 处理命令
    command(cmd, id) {
      if (cmd === 'ban') {
        this.$confirm('此操作将禁用此账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          blockAdmin(id).then(res => {
            if (res.code === 200) {
              this.$message({
                message: "已禁用",
                type: "success"
              });
            }
            this.getTableData()
          })
        }).catch(() => {
        });
      }
      if (cmd === 'unban') {
        this.$confirm('确定解禁该账号吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          unblockAdmin(id).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: "已解禁"
              });
              this.getTableData()
            }
          })
        }).catch(() => {
        });
      }
      if (cmd === 'resetPass') {
        this.$confirm('确定重置该账号密码吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resetPassword(id).then(res => {
            if (res.code === 200) {
              this.$message({
                message: "已重置",
                type: "success"
              });
            }
            this.getTableData()
          })
        }).catch(() => {
        });
      }
    },
    // 显示手机端更多操作菜单
    showMoreActions(row) {
      this.currentRow = row
      this.showActionSheet = true
    },
    // 处理手机端操作菜单选择
    onActionSheetSelect(action, index) {
      if (action.name === '重置密码') {
        this.handleResetPassword(this.currentRow.id)
      } else if (action.name === '禁用账号') {
        this.handleBan(this.currentRow.id)
      } else if (action.name === '解禁账号') {
        this.handleUnban(this.currentRow.id)
      }
      this.showActionSheet = false
    },
    // 处理重置密码
    handleResetPassword(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定重置该账号密码吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(() => {
        resetPassword(id).then(res => {
          if (res.code === 200) {
            Toast({
              message: '已重置',
              type: 'success',
              duration: 2000
            })
            this.getTableData()
          }
        })
      })
      .catch(() => {
        // 取消操作
      })
    },
    // 处理禁用账号
    handleBan(id) {
      Dialog.confirm({
        title: '提示',
        message: '此操作将禁用此账号, 是否继续?',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(() => {
        blockAdmin(id).then(res => {
          if (res.code === 200) {
            Toast({
              message: '已禁用',
              type: 'success',
              duration: 2000
            })
            this.getTableData()
          }
        })
      })
      .catch(() => {
        // 取消操作
      })
    },
    // 处理解禁账号
    handleUnban(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定解禁该账号吗?',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(() => {
        unblockAdmin(id).then(res => {
          if (res.code === 200) {
            Toast({
              message: '已解禁',
              type: 'success',
              duration: 2000
            })
            this.getTableData()
          }
        })
      })
      .catch(() => {
        // 取消操作
      })
    },
    // 关闭手机端操作菜单
    onActionSheetClose() {
      this.currentRow = null
    },
    handleSizeChange(val) {
      this.params.page_count = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getTableData()
    },
    // 处理 Vant 搜索框取消事件
    onSearchCancel() {
      this.searchKeyword = ''
      this.getTableData()
    },
    // 关闭添加/修改 - 电脑端
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.addDrawer = false;
          this.editDrawer = false;
        })
        .catch((_) => { });
    },
    // 关闭弹窗 - 手机端
    handleClosePopup(type) {
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(() => {
        if (type === 'add') {
          this.addPopup = false;
        } else if (type === 'edit') {
          this.editPopup = false;
        }
      })
      .catch(() => {
        // 取消关闭
      })
    },
    
    // 弹窗打开时禁止页面滚动
    handlePopupOpen() {
      document.body.style.overflow = 'hidden';
    },
    
    // 弹窗关闭时恢复页面滚动
    handlePopupClose() {
      document.body.style.overflow = '';
    },
    // 添加/修改成功 - 电脑端
    handleDrawerSuccess() {
      this.addDrawer = false;
      this.editDrawer = false;
      this.getTableData();
      if (this.$refs.newForm && this.$refs.newForm.$refs.form) {
        this.$refs.newForm.$refs.form.resetFields();
      }
    },
    // 添加/修改成功 - 手机端
    handlePopupSuccess() {
      this.addPopup = false;
      this.editPopup = false;
      this.getTableData();
      if (this.$refs.newForm && this.$refs.newForm.$refs.form) {
        this.$refs.newForm.$refs.form.resetFields();
      }
    },
    // 清空子组件
    clearContent() {
      if (this.$refs.newForm && this.$refs.newForm.$refs.form) {
        this.$refs.newForm.$refs.form.resetFields();
      }
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    this.initData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.search-container h2 {
  margin-bottom: 20px;
  color: var(--text);
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

/* 手机端添加按钮样式 */
.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

.mobile-search-container {
  margin-bottom: 15px;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

/* 标签页容器 */
.tabs-container {
  margin-bottom: 15px;
}

/* 电脑端表格 */
.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions{
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-title {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.card-title h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-realname {
  font-size: var(--font-size-sm);
}

.card-content {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

/* Vant按钮样式优化 */
.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

/* Vant下拉菜单样式优化 */
.card-actions .van-dropdown-menu {
  font-size: 13px;
  flex-shrink: 0;
}

/* 手机端空状态 */
.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 适配小屏幕，确保操作按钮不会换行 */
@media (max-width: 375px) {
  .card-actions {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  
  .card-actions .van-button {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
  
  .card-actions .van-dropdown-menu {
    width: 100%;
  }
}

/* 手机端弹窗样式 */
.popup-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--background);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--background);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.popup-header h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text);
}

.popup-header .close-icon {
  font-size: 20px;
  color: var(--text-200);
  cursor: pointer;
  transition: color 0.2s ease;
}

.popup-header .close-icon:hover {
  color: var(--text);
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--background);
}

/* 筛选面板样式 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
}

/* 分页（固定） */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-container h2 {
    margin-bottom: 15px;
  }
  
  .search-container .search-input {
    display: none;
  }
  
  .content-container {
    padding: 10px 0;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .pagination-container {
    text-align: center;
    padding: 15px;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-select,
  .filter-item .el-input-number {
    width: 100% !important;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }
  
  .desktop-table {
    display: block;
  }
  
  .mobile-cards {
    display: none;
  }
}

@media (max-width: 768px) {
  .search-container{
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }
  .van-search{
    padding:0;
  }
  .desktop-table {
    display: none;
  }
  
  .mobile-cards {
    display: flex;
  }
  
  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-input {
    max-width: 100%;
  }
}
</style>